    import {useNavigate, useParams} from "react-router-dom"
    import {useEffect, useState} from "react"

    import {DashboardLayout} from "../../layouts/DashboardLayout"
    import {CourseHeader} from "./components/CourseHeader"
    import {CourseGroupChat} from "./components/CourseGroupChat"
    import {CourseLessonsList} from "./components/CourseLessonsList"
    import {CoursePrivatePeersList} from "./components/CoursePrivatePeersList";

    export const CourseChatPage = () => {
        const {courseId} = useParams<{courseId: string}>()

        if (!courseId) return null

        return (
            <DashboardLayout title="Чат курса">
                <div className="max-w-5xl space-y-6">
                            <BackButton />

                    <CourseHeader />

                    <CourseGroupChat courseId={courseId} />

                    <CoursePrivatePeersList courseId={courseId} />
                </div>
            </DashboardLayout>
        )
    }

    export const BackButton = () => {
        const navigate = useNavigate()

        return (
            <button
                onClick={() => navigate(-1)}
                className="
                    flex items-center gap-2
                    text-sm
                    text-gray-500
                    hover:text-gray-700
                    transition
                "
            >
                ← Назад
            </button>
        )
    }
